import api from './api';

const productService = {
  /**
   * ADMIN catalog: paginated, includes inactive products, supports search. @Roles('admin'), so a
   * sales_rep or clinic login gets 403. Only the admin Products page may use this.
   */
  getProducts: (params) => api.get('/admin/products', { params }),

  /**
   * THE PRODUCT PICKER (CL-260824-08). Active products only, and NOT admin-guarded.
   *
   * Every order picker used getProducts() - the admin route - so the moment a sales_rep or clinic
   * login opened New Order they got a 403, the catch turned it into an empty list, and the dropdown
   * rendered with no products and no error. Submitting an order is the entire point of those two
   * roles, and it was impossible for them.
   */
  getActiveProducts: () => api.get('/products'),
  getProductById: (id) => api.get(`/admin/products/${id}`),
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
};

export default productService;
